import { useSyncExternalStore } from "react";

import {
  getNotificationPermissionState,
  subscribeNotificationPermission,
} from "@/lib/notifications/system-notifications";

// Reactive read of this browser's notification permission: 'unsupported' | 'insecure' |
// 'default' | 'granted' | 'denied'. The snapshot is a primitive string, so it slots straight
// into useSyncExternalStore; it refreshes after an Enable click, a Permissions API change event,
// or when the window regains focus (site settings are edited outside the page).
export function useNotificationPermission() {
  return useSyncExternalStore(
    subscribeNotificationPermission,
    getNotificationPermissionState,
    getNotificationPermissionState,
  );
}
